import { OpcionModel } from '../Global/Opcion.model';

/**
* @author Camilo
* @since  03/11/2017
**/
export class ConceptoModel{
	constructor(public id:MchPrefacturadetalleconceptosId){}

}


export class MchPrefacturadetalleconceptosId{

	constructor(public cid:string,
		public cnumcont:string,
		public ccodcon:string, 
		public referencia1:string, 
		public referencia2:string,
		public referencia3:string,
		public referencia4:string,
		public unidades:number,
		public valorunidad:number,
		public nbase:number,
		public niva:number,
		public nestado:number, 
		public ndescuento:number,
		public nvalorimpuestoconsumo:number){}	
}

export class ConceptoOpcionModel{
		
		constructor(public ccodcon:string,
			public cdescon:string,
			public nporcentaje:number,
			public nporcentajeimpuestoconsumo:number,
			public ncobraimpuestoconsumo:number) {}
}


// WEBPACK FOOTER //
// D:/Repositorios/FacturacionWeb/src/app/main/content/CrearFactura/Concepto.model.ts